var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{on:{"click":function($event){return _vm.actionCb(_vm.scope)}}},[_vm._v(_vm._s(_vm.scope.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }